import React from "react";

export default function Loader() {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-container">
        <div className="spinner-border"></div>
        <div>Chargement...</div>
      </div>
    </div>
  )
}
